import { memo } from "react";

import useAppSelector from "../utils/hooks/useAppSelector";

import Situation from "./Situation";

function Situations() {
  const situations = useAppSelector((state) => state.situations);

  return (
    <div
      style={{
        backgroundColor: "transparent",
        display: "flex",
        flexDirection: "column",
        gap: 5,
        marginBottom: 10,
      }}
    >
      {situations?.map((situation) => {
        return <Situation key={situation.id} situation={situation} />;
      })}
    </div>
  );
}

export default memo(Situations);
